import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { ServicePlanItem } from 'src/features/servicePlanItems/utils/types';
import { useCreateServicePlanItem } from 'src/features/servicePlanItems/api/useCreateServicePlanItem';
import { LIST_SERVICE_PLAN_ITEMS_RESOURCE } from 'src/features/servicePlanItems/api/useListServicePlanItems';
import { servicePlanItemsMessages } from 'src/features/servicePlanItems/utils/messages';
import ServicePlanItemFormModal from 'src/features/servicePlanItems/components/forms/ServicePlanItemFormModal';

interface CreateServicePlanItemFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedServicePlanItem?: ServicePlanItem;
    children?: React.ReactNode;
}

function CreateServicePlanItemFormModal<TData>({ className, semantics }: CreateServicePlanItemFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateServicePlanItem({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SERVICE_PLAN_ITEMS_RESOURCE] });
            toast({
                title: formatMessage(servicePlanItemsMessages.createServicePlanItemSuccess),
                description: formatMessage(servicePlanItemsMessages.createServicePlanItemSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <ServicePlanItemFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(servicePlanItemsMessages.addServicePlanItemSubtitle)}
        />
    );
}

export default CreateServicePlanItemFormModal;
